import { Youtube, Instagram, Facebook, Linkedin } from "lucide-react";

const CHANNEL = "https://www.youtube.com/@motivationunlockedforever?sub_confirmation=1";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-14" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <div className="flex items-center gap-2">
              <img src="/logo-red.png" alt="Motivation Unlocked" className="h-12 w-auto" />
            </div>
            <p className="mt-4 text-sm text-white/50 max-w-sm">
              Mindset. Discipline. Breakthrough. Hosted by Marc Black, CEO.
            </p>
          </div>

          <div className="flex items-center gap-3">
            {[
              { icon: Youtube, href: CHANNEL, label: "YouTube" },
              { icon: Instagram, href: "https://www.instagram.com/marcblackceo/", label: "Instagram" },
              { icon: Facebook, href: "https://www.facebook.com/marcblackceo", label: "Facebook" },
              { icon: Linkedin, href: "https://www.linkedin.com/in/marcblackceo/", label: "LinkedIn" },
            ].map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                aria-label={s.label}
                className="rounded-full border border-white/20 p-3 hover:bg-blaze hover:border-blaze transition-colors"
                data-testid={`footer-social-${s.label.toLowerCase()}`}
              >
                <s.icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Motivation Unlocked. All rights reserved.</p>
          <p>Built for those ready to unlock the next version of themselves.</p>
        </div>
      </div>
    </footer>
  );
}
